import React, { useEffect, useRef } from "react";
import audio_map from './final_user_to_dst3';

import { useState } from "react";
import {Button} from '@mui/material';
import {LoadQuestion, Login, Done, ShowConditions, ShowReferralForm} from "./components";
import {CircularwithLabel} from "./Components/ProgressBars/LinearProgress";
import {useAuthState} from 'react-firebase-hooks/auth';
import {auth, database, storage} from './firebase';
import {SampleAudioQuiz, SampleAudioTable} from "./audiotable_code";
// import { collection,doc,setDoc,addDoc } from "firebase/firestore";
import { ref, getDownloadURL } from "firebase/storage";

// import sha1 from 'sha1';
import { Timestamp} from 'firebase/firestore';
import NavBar from "./Components/Navigation/NavigationBar";
import { CgOpenCollective } from "react-icons/cg";

// Set-ExecutionPolicy -Scope Process -ExecutionPolicy Bypass
const audios = audio_map;

const NUMBER_OF_AUDIOS = 55;

export default function App() {
  //variable declaration
  const [surveySource, setSurveySource] = useState("");
  const [otherSource, setOtherSource] = useState("");
  
  const [audiosState, setAudios] = useState(audio_map);
  const [audio_keys, setAudioKeys] = useState(Object.keys(audios));
  // console.log("audio keys - ",audio_keys);
  const [isInterestedInReferral, setIsInterestedInReferral] = useState(false);
  // const [user_ids, setIds] = useState(Object.keys(audios));
  const [prev_responses, setPrevResponse] = useState({});
  const [accuracy_data, setAccuracyData] = useState({});
  const [inputs, setInputs] = useState({});
  const [isDone, setDone] = useState(false);
  const [user] = useAuthState(auth);
  const [is_tutorial_complete, setIsTutorialComplete] = useState(null);
  const [currInd, setInd] = useState();
  const [currId, setCurrId] = useState();
  const [mixSet, setMixSet] = useState();
  const [mixSetDisabled ,setMixSetDisabled] = useState(false);
  const [currAudio, setCurrAudio] = useState();
  const [tutorial_index_list, setTutorialIndexList] = useState(null);
  // const [currText, setText] = useState();

  const [isEnded, setEnded] = useState(false);
  const [totalFiles, setTotalFiles] = useState(0)


  // const [noise_counter,setNoise_counter] = useState(1);
  const [isBreakMusic, setIsBreakMusic] = useState(false);
      // setAudio_list(audios_list)
  const [break_music_url,setBreakMusicUrl] = useState();
  const [metaFormShow, setMetaFormShow] = useState(false);

  
  const [age,setAge] = useState();
  const [fullname,setFullname] = useState();
  
  const [gender,setGender] = useState();
  const [letterRemuneration,setLetterRemuneration]= useState("Remuneration");
  const [lang,setLang] = useState();
  const [phn,setPhn] = useState();

  const [consistent, setConsistent] = useState(0);
  const [consistent_count, setConsistentCount] = useState(0);
  const [acc, setAcccuracy] = useState(0);
  const [acc_count, setAccuracyCount] = useState(0);
  const [score, setScore] = useState('N/A');

  const audioBreakMusicRef = useRef();
  const audioRef =  useRef();

  
  const is_interested_in_referral =() => {
    setIsInterestedInReferral(true);
  };

  const ShowBreakMusic=()=>{
    function getUrl(filename) {
      console.log("getBreakMusicUrl Function for file ", filename);
      getDownloadURL(ref(storage, filename))
          .then((url) => {
            setBreakMusicUrl(url)
          });
      // setUrl("https://docs.google.com/uc?export=download&id="+filename)
  }
  getUrl('break_music.mp3');
      setIsBreakMusic(true);
  
  }
  
  const handleBreakMusicPlay = (event) => {
    audioBreakMusicRef.current.play();
  }

  const handleBreakMusicEnded = (event) => {
    setIsBreakMusic(false);
  }

  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    // event.target.checked = true;
    
    // console.log("Event.target =",event.target);
    setInputs(values => ({...values, [name]: value}))

  }

  const saveTutorialComplete = (event) => {
    database.ref(user.uid + "/is_tutorial_complete").set(true);
    
  }

  const calculate_score = (currAudio, choice) => {
    
    if ((consistent_count == 0) && Object.keys(prev_responses).length > 0){

      Object.keys(prev_responses).forEach( key => {
        // console.log("Key being looped through = ", key)
        if (Array.isArray(prev_responses[key])) {
          setConsistentCount(consistent_count => {return consistent_count + 1});
          for(var i=0; i<prev_responses[key].length; i+=2) {
            if(prev_responses[key][i] == prev_responses[key][i+1]) {
              setConsistent(consistent => {return consistent + 1 });            
            }
          }
        }
      });
    }

    if (currAudio != null & choice != null) {
      if (currAudio in prev_responses) {
        setConsistentCount(consistent_count => {return consistent_count + 1});
        if (prev_responses[currAudio] == choice) {
            setConsistent(consistent => {return consistent + 1 });            
        }
      }
    }
    const filename=currAudio.replace('data_sample_150/', '').replace('.wav','');
    
    if (filename in accuracy_data) {
      setAccuracyCount(acc_count => {return acc_count + 1});
      if (accuracy_data[filename] == choice) {
        setAcccuracy(acc => {return acc+1});
      }
    }
  };

  useEffect(()=>{
      if ((acc_count != 0 ) || (consistent_count != 0)){
        if ((acc_count >0)  && (consistent_count > 0)){
          setScore(Math.round(100*Math.min(acc/acc_count, consistent/consistent_count)) + '%');
        } else if ((acc_count == 0) && (consistent_count > 0)) {
          setScore(Math.round(100*consistent/consistent_count) + '%');
        } else { // consistency_count is 0
          setScore(Math.round(100*acc/acc_count) + '%');
        }
      }
      }, [acc, acc_count, consistent, consistent_count] );


  const handleSubmit = (event) => {
    if (user) {
      if (Object.keys(inputs).length !== 1) {
          alert("Please select an option for the question")
      }

      else {
        audioRef.current.src="";
        setEnded(false);
        database.ref(user.uid + "/data/" + currId).set({
          audio1: currAudio,
          timestamp: Timestamp.now().toDate().toString(),
          email: user.email,
          data: inputs   
        }).catch(alert)
        // const temp = prev_responses
        // temp[currAudio] = inputs[1];

        

        // console.log("Added new entry in prev_responses = ", prev_responses[currAudio]);
        if ((currInd > 10) || (currAudio in prev_responses) ){
          // Calculate the score for the user
          if ((accuracy_data!= null) && (Object.keys(accuracy_data).length > 0)){
            // proceed with score calculation if the accuracy data is already available
            calculate_score(currAudio, inputs[1]);
          } else {
            // fetch the accuracy data and give some time for the data to download
            // and calculate the score the next time around
            fetch_accuracy_data();
          }

        }

        setPrevResponse(prev_responses => {return {...prev_responses, [currAudio]:inputs[1]}});
        database.ref(user.uid + "/index").set(currInd + 1)
        setInd(currInd+1);
      }
    }
  }

  function ConvertToArray(list_of_numbers){
    if (list_of_numbers.length == 0) {
      return new Array();
    } else {
      return list_of_numbers.split(',').map(Number);
    }
  }

  const checkMixSet = async (mix_set) => {
    try {
      // Reference to the "user_mix_set" key in Firebase Realtime Database
      const disabledUserMixSetRef = database.ref('/info/setup/user_mixset_disable');

      // Fetch data from Firebase
      const snapshotDisabledMixSet = await disabledUserMixSetRef.once('value');

      // Get the mix_Set data
      const disabled_mix_Set = ConvertToArray(snapshotDisabledMixSet.val());
      // console.log("disabled User list = ", disabled_mix_Set);
      // Check if the user's mix_set is part of disabled mix_set. If yes, set flag
      setMixSetDisabled(disabled_mix_Set.includes(mix_set));
      
    } catch (error) {
      console.error('Error fetching data from Firebase:', error.message);
    }
  };

  const fetch_mix_set = async () => {
    try {
      // Reference to the "user_mix_set" key in Firebase Realtime Database
      const userMixSetRef = database.ref('user_mix_set');
      const allowedUserMixSetRef = database.ref('/info/setup/user_mixset_allowed');
      // const disabledUserMixSetRef = database.ref('/info/setup/user_mixset_disable');

      // Fetch data from Firebase
      const snapshot = await userMixSetRef.once('value');
      const snapshotAllowedMixSet = await allowedUserMixSetRef.once('value');
      // const snapshotDisabledMixSet = await disabledUserMixSetRef.once('value');

      let ind = 0;
      setInd(ind);
      // setId(ind);
      // Get the mix_Set data
      var mix_Set = snapshot.val();
      const allowed_mix_Set = ConvertToArray(snapshotAllowedMixSet.val());
      // console.log("allowed User list = ", allowed_mix_Set);
      // const disabled_mix_Set = ConvertToArray(snapshotDisabledMixSet.val());
      // console.log("disabled User list = ", disabled_mix_Set);
      var all_complete_flag = 0;

      while (!allowed_mix_Set.includes(mix_Set) && all_complete_flag  <=1) {
        if (mix_Set +1 < NUMBER_OF_AUDIOS) {
          mix_Set++;
        } else {
          mix_Set = allowed_mix_Set[(Math.floor(Math.random() * allowed_mix_Set.length))];
          all_complete_flag++;
        }
      }
      if (all_complete_flag <= 1){
        if (mix_Set + 1 < NUMBER_OF_AUDIOS ){
          database.ref("user_mix_set").set(mix_Set + 1);
        } else {
          database.ref("user_mix_set").set(0);
        }
        console.log("fetch_mix_set , value obtained = ", mix_Set);
        setMixSet(mix_Set);
        database.ref(user.uid + "/mixSet").set(mix_Set)
        setAudios(audios[String(mix_Set)]);
        setAudioKeys(Object.keys(()=>{return audiosState;}));
        setCurrAudio(audios[String(mix_Set)][currInd]);
        setTotalFiles(Object.getOwnPropertyNames(audios[String(mix_Set)]).length);
      } else {
        console.log("All MixSets have been used , value obtained = ");
        mix_Set = -1;
        setMixSet(mix_Set);
      }
      // Set the data in the state
      
    } catch (error) {
      console.error('Error fetching data from Firebase:', error.message);
    }
  };

  
  const handleChange_fullname=(event)=>{
    const value = event.target.value;
    setFullname(value)
  };
  const handleChange_age=(event)=>{
    const value = event.target.value;
    setAge(value)
  };
  const handleChange_gender=(event)=>{
    const value = event.target.value;
    setGender(value)
  };

  const handleChange_letter_remuneration=(event)=>{
    const value = event.target.value;
    setLetterRemuneration(value)
  }

  const handleChange_lang=(event)=>{
    const value = event.target.value;
    setLang(value)
  };

  const handleChange_phn=(event)=>{
    const value = event.target.value;
    setPhn(value)
  };
 
  const setTutorialCompleteState = (event) => {

    setIsTutorialComplete(true);
  };


  // const handleMetaFormSubmit = async (event) => {
  //   if (!age || !gender || !lang || !phn || !fullname) {
  //     alert("Please select an option.");
  //   } else if (fullname.length < 3 ) {
  //     alert("Name not entered")
  //   }else if (age < 1 || age > 100) {
  //     alert("Invalid age data.");
  //   } else if (phn.length !== 10) {
  //     alert("Invalid phone number.");
  //   } else if (age && gender && lang && phn && fullname) {
  //     try {
  //       const uid = user.uid;
  
  //       // Set data for "meta" document
  //       await database.ref("/info/"+uid).set( 
  //         {
  //           "name":fullname,
  //           "age": age,
  //           "gender": gender,
  //           "language": lang,
  //           "Phone_no": phn,
  //           "uid": uid,
  //           "email": user.email,
  //           "letter_or_remuneration":letterRemuneration
  //         }
  //       );
  //       setIsTutorialComplete(false);
  //       // Handle form submission success
  //       setMetaFormShow(false);
  //       // setMetaformsubmit(true);
  //     } catch (error) {
  //       console.error("Error setting document:", error.message);
  //     }
  //   }
  // };
  const handleMetaFormSubmit = async (event) => {
    if (!age || !gender || !lang || !phn || !fullname || !surveySource) {
      alert("Please select an option for all required fields.");
    } else if (fullname.length < 3 ) {
      alert("Name not entered")
    } else if (age < 1 || age > 100) {
      alert("Invalid age data.");
    } else if (phn.length !== 10) {
      alert("Invalid phone number.");
    } else if (surveySource === "Other" && !otherSource) {
      alert("Please specify where you heard about this survey.");
    } else if (age && gender && lang && phn && fullname && surveySource) {
      try {
        const uid = user.uid;
        
        // Determine the final source value
        const finalSource = surveySource === "Other" ? otherSource : surveySource;
  
        // Set data for "meta" document
        await database.ref("/info/"+uid).set( 
          {
            "name": fullname,
            "age": age,
            "gender": gender,
            "language": lang,
            "Phone_no": phn,
            "uid": uid,
            "email": user.email,
            "letter_or_remuneration": letterRemuneration,
            "survey_source": finalSource
          }
        );
        setIsTutorialComplete(false);
        // Handle form submission success
        setMetaFormShow(false);
        // setMetaformsubmit(true);
      } catch (error) {
        console.error("Error setting document:", error.message);
      }
    }
  };
  const signout = () => {
    auth.signOut();
  };

  const fetch_accuracy_data = async() => {
    try {
      const snapshot = await database.ref('/info/setup/reference').once('value');
      const originalData = snapshot.val();
      
      setAccuracyData(originalData);
      // console.log("accuracy data downloaded = ", accuracy_data);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const fetch_prev_responses = async (event) => {
    database.ref("/"+user.uid+"/data").get().then((originalData) => {
      if (originalData.exists()) {
        // Go through the various responses
        console.log("prev_responses length = " + originalData.val().length);
        if((originalData.val().length < 100) & (originalData.val().length > 0)) {
          const prev_data = {};
          for (const key in originalData.val()) {
            // console.log("key = ", key);
            if (originalData.val().hasOwnProperty(key)) {
              const audio = originalData.val()[key].audio1;
              const dataValue = Object.values(originalData.val()[key].data)[0];
              if (audio in prev_data) {
                prev_data[audio] = [prev_data[audio], dataValue];

              } else {
                
                prev_data[audio] = dataValue;
              }
            }
          }
          setPrevResponse(prev_data);
        }
      }
    }).catch((error) => {
      console.log("error fetching previous responses");
    }) 
  };

  // useEffect(() => {
  //   console.log("Detected change in prev_responses, value = ", prev_responses);
  // }, [prev_responses]);

  useEffect(() => {
    function shuffle(array) {
      var i = array.length,
          j = 0,
          temp;
  
      while (i--) {
  
          j = Math.floor(Math.random() * (i+1));
  
          // swap randomly chosen element with current element
          temp = array[i];
          array[i] = array[j];
          array[j] = temp;
  
      }
  
      return array;
    }
  
    if(user){
      database.ref("/info/"+user.uid).get().then((infoSnapshot) => {
        if (!infoSnapshot.exists()) {
          // Show the registration page
          console.log("DB Snapshot did not exist");
          setMetaFormShow(true);
        } else {
          database.ref(user.uid).get().then((snapshot) => {
            if (snapshot.exists()) {
              console.log("Existing user")
              const ind = snapshot.val()["index"];
              const mix_Set = snapshot.val()["mixSet"];
              const is_tutorial_complete = snapshot.val()['is_tutorial_complete']
              const tutorial_index_list = snapshot.val()['tutorial_index_list'];
              console.log("existing user mix set = ", mix_Set, "fetching audio", String(mix_Set));
              // console.log("is_tutorial_complete = ", is_tutorial_complete, is_tutorial_complete==null)
              setInd(ind);
              
              if (tutorial_index_list == null) {
                 setTutorialIndexList(shuffle([0,1,2,3,4,5,6,7,8]));
              } else {
                setTutorialIndexList(tutorial_index_list);
              }

              setIsTutorialComplete(is_tutorial_complete);

              checkMixSet(mix_Set);
              setMixSet(mix_Set);
              setAudios(audios[String(mix_Set)]);
              setAudioKeys(Object.keys(()=>{return audiosState;}));
              setCurrAudio(audios[String(mix_Set)][ind]);
              setTotalFiles(Object.getOwnPropertyNames(audios[String(mix_Set)]).length);
              fetch_prev_responses();
              
            }
            else {
    
              console.log("Creating new user");
              database.ref(user.uid + "/index").set(0);
              fetch_mix_set();
              setMetaFormShow(true);  
              const tutorial_index_list = shuffle([0,1,2,3,4,5,6,7,8]);
              database.ref(user.uid+"/tutorial_index_list").set(tutorial_index_list);
              setTutorialIndexList(tutorial_index_list);        
            }
          }).catch((error) => {
            console.error("Index error", error);
          });
        }
      }).catch((error) => {
        console.error("Database Connection Error", error);
      });
      // console.log("useEffect Triggered")
      database.ref(user.uid).get().then((snapshot) => {
        if (snapshot.exists()) {
          const ind = snapshot.val()["index"];
          const mix_Set = snapshot.val()["mixSet"];
          const is_tutorial_complete = snapshot.val()['is_tutorial_complete']
          const tutorial_index_list = snapshot.val()['tutorial_index_list'];
          console.log("mix set = ", mix_Set, "fetching audio", String(mix_Set));
          setInd(ind);
          // setId(ind);
          setMixSet(mix_Set);
          setIsTutorialComplete(is_tutorial_complete);
          setAudios(audios[String(mix_Set)]);
          setAudioKeys(Object.keys(()=>{return audiosState;}));
          setCurrAudio(audios[String(mix_Set)][ind]);
          setTotalFiles(Object.getOwnPropertyNames(audios[String(mix_Set)]).length);
          if (tutorial_index_list == null) {
            setTutorialIndexList(shuffle([0,1,2,3,4,5,6,7,8]));
          } else {
            setTutorialIndexList(tutorial_index_list);
          }
          fetch_prev_responses();
          
        }
        else {

          console.log("Creating new user");
          database.ref(user.uid + "/index").set(0);
          fetch_mix_set();
          setMetaFormShow(true);  
          const tutorial_index_list = shuffle([0,1,2,3,4,5,6,7,8]);
          database.ref(user.uid+"/tutorial_index_list").set(tutorial_index_list);
          setTutorialIndexList(tutorial_index_list);          
        }
      }).catch((error) => {
        console.error("Index error", error);
      });

    }

  }, [user]);

  useEffect(() => {
    // console.log("Ind", currInd)
    if (currInd !== undefined) {
      // console.log("currInd = ", currInd, " totalFiles =", totalFiles);
      // console.log("audio_keys.length = ", audio_keys.length, totalFiles );
      if(currInd < totalFiles){
        // console.log("currInd", currInd)
        setCurrAudio(audios[mixSet][currInd]);
        // setText(texts[ids[currInd]]);
        setInputs({});
        setCurrId(currInd);
      }
      else{
        auth.signOut();
        setDone(true);
      }
    }

 }, [currInd, totalFiles, mixSet]);

 useEffect(()=>{
  if ((currId !== undefined) && (currId > 0) && (currId%10 == 0)) {
    setIsBreakMusic(true);
    ShowBreakMusic();
  }
 }, [currId]);

 return (
  <>
  <div className= "heading">
    {user && is_tutorial_complete &&
    <NavBar />
    }
    
    <div className="top-content">
    
    <div className="sign-out-button">
      {user && <Button className="sign_out_button" variant="contained" 
              onClick={signout}
              style={{minWidth: '50px', maxHeight: '30px'}} >Sign out </Button>
      }
      </div>
      </div>
    <div className="heading-text">
      <h1> Speech Intelligibility Survey
      </h1>
      </div >
      
  </div>
      {
        mixSetDisabled && <div id="disabled_set">
          <h5>Thank you very much for your patience. Currently, we are narrowing down on our data. Please check back soon for any changes.</h5>
          <div id="terms-and-conditions">
            <p><strong>
              Terms & Conditions</strong></p>
            <div id="conditions-text">
            <ShowConditions showFull={true} />
                <ShowReferralForm />
              </div>
            </div>
        </div>
      }
      {
        !mixSetDisabled && mixSet < 0 && <div id="survey-complete">
          <h5>Thank you very much for your patience. Currently, we are narrowing down on our data. Please check back soon for any changes.</h5>

          
          <div id="terms-and-conditions">
          <p><strong>
            Terms & Conditions</strong></p>
            <div id="conditions-text">
              <ShowConditions showFull={true} />
              <ShowReferralForm />
            </div>
            </div>
        </div>
      }
      
      {
        !user &&  !isDone && <Login
          user={user} 
          isInterestedInReferral={isInterestedInReferral}
          is_interested_in_referral={is_interested_in_referral}
          />
      }
      {
        user && metaFormShow && mixSet >= 0 && !mixSetDisabled && <div id="user-detail-form">
        <br></br>
        <h5>Please fill the form below.</h5>
        <br></br>

      <div className="input-field form-group required">
          <label htmlFor="fullname" className="control-label">
            <h5>Name</h5>
          </label>
          <input
            type="text"
            min="1"
            max="50"
            id="fullname"
            onChange={(e) => handleChange_fullname(e)}
            className="form-control"
          ></input>
      </div>

      <div className="input-field form-group required">
          <label htmlFor="age" className="control-label">
            <h5>Age in years</h5>
          </label>
          <input
            type="number"
            min="1"
            max="100"
            id="age"
            onChange={(e) => handleChange_age(e)}
            className="form-control"
          ></input>
      </div>

      <div className="input-field form-group top-padding-gap required">
          <label htmlFor="gender" className="control-label">
          <h5>Gender</h5>
          </label>
          <br></br>
          <select className="gender-dropdown" id="gender" type="gender" onChange={(e) => handleChange_gender(e)}>
            <option defaultValue value="">Select</option>
            <option  value="Male">Male</option>
            <option value="Female">Female</option>
          </select> 
      </div>

      <div className="input-field form-group top-padding-gap required">
          <label htmlFor="lang" className="control-label">
          <h5>Native Language</h5>
          </label>
          <input
            type="lang"
            id="lang"
            onChange={(e) => handleChange_lang(e)}
            className="form-control"
          ></input>
      </div>

      <div className="input-field form-group top-padding-gap required">
          <label htmlFor="phno" className="control-label">
          <h5>GPay/PhonePe Number</h5>
          </label>
          <input
            type="phno"
            id="phno"
            onChange={(e) => handleChange_phn(e)}
            className="form-control"
          ></input>
      </div>

      <div className="input-field form-group top-padding-gap required">
          <label htmlFor="gender" className="control-label">
          <h5>Do you prefer Remuneration or a Letter</h5>
          </label>
          <br></br>
          <select className="let_remun-dropdown" id="letter_remuneration" type="letter_remuneration" onChange={(e) => handleChange_letter_remuneration(e)}>
            <option defaultValue value="Remuneration">Remuneration</option>
            <option  value="Letter">Contribution e-Letter</option>
          </select> 
      </div>

      <div className="input-field form-group top-padding-gap required">
        <label htmlFor="source" className="control-label">
        <h5>Where did you hear about this survey?</h5>
        </label>
        <br></br>
        <select 
          className="source-dropdown" 
          id="source" 
          type="source" 
          onChange={(e) => {
            setSurveySource(e.target.value);
            if (e.target.value !== "Other") {
              setOtherSource("");
            }
          }}
        >
          <option defaultValue value="">Select</option>
          <option value="College">College</option>
          <option value="Referral/Friend">Referral/Friend</option>
          <option value="Social Media">Social Media</option>
          <option value="Other">Other</option>
        </select>
    </div>

    {surveySource === "Other" && (
      <div className="input-field form-group top-padding-gap required">
          <label htmlFor="otherSource" className="control-label">
          <h5>Please specify:</h5>
          </label>
          <input
            type="text"
            id="otherSource"
            maxLength="100"
            onChange={(e) => setOtherSource(e.target.value)}
            className="form-control"
            placeholder="Max 100 characters"
          ></input>
      </div>
    )}


      <br />
      <strong>Note:</strong>Remuneration shall be paid only if the responses' scores are more than 80%. Accuracy shall be calculated by our internal libraries
        <div className='submit-button-wrapper'>
        <Button variant="contained" className='submit-button' onClick={handleMetaFormSubmit}>Submit</Button>
          
        </div>
      <br/>
      </div>
      }{
      !isDone && user && !metaFormShow && (currId !== undefined) && 
            ((is_tutorial_complete==null )|| (is_tutorial_complete == false)) && 
            <div id="tutorial_container">
              <div id="tutorial-description">
                <div className="tutorial-description-text">
                <p>
                  Before you invest your precious time, see if you are able to pass this below mini-quiz. The below quiz helps you gauge your scoring-ability. 
                Succeeding in this quiz may increases the chances of a good score in the main quiz.
                </p>
                </div>
              </div>
              
              <SampleAudioQuiz 
                tutorial_index_list={tutorial_index_list}
                setTutorialCompleteState={setTutorialCompleteState}
                saveTutorialComplete={saveTutorialComplete}
                />

            </div>
      }
      {
        !isDone && user && !metaFormShow && (currId !== undefined) && (isBreakMusic) &&
             is_tutorial_complete  && <div id="break_music">
        {<div className="audio-wrapper">
          <p>Let's Take a break and listen to music for a few seconds...</p>
          <audio className="audio-player" src={break_music_url} ref={audioBreakMusicRef} onEnded={handleBreakMusicEnded}>
            </audio>
          </div> } 
        <Button variant="contained" onClick={handleBreakMusicPlay} >Play audio </Button>

              <img url="./sound.gif"/>
          </div>
      }
    { 
    !isDone && user && !metaFormShow && (currId !== undefined)&& (!isBreakMusic)&& 
      mixSet >= 0 && !mixSetDisabled && is_tutorial_complete && <form >
      <div className= "form-wrapper">
        <div className="instruction-container">
          <div className="instruction-text">
        <strong>Quick Instructions</strong> <br/>
        <ul>
          <li>Press Play Audio</li>
          <li>Use headphones or earphones to listen to the audio <strong>one or more number of times</strong> </li>
          <li>Select the appropriate option below that indicates the quality of the audio </li>
          </ul>
          </div>
          <div className="progress-meters">
            <div className="circular-progress">
              <CircularwithLabel value={currInd} width="100px" height="100px"/>
            </div>
            <div className="score-progress">
              <div className="title">Score</div>
              <div id = "score-value" className="score-value">
                {score}
              </div>
            </div>
          </div>
          </div>
          <hr /> 
      
          <div className="questions">
              <LoadQuestion 
              index={currInd}
              id={currId}
              audio={currAudio} 
              audioRef={audioRef}
              handlechange={handleChange}
              handleEnded={setEnded}
              handleSubmit={handleSubmit}
              ended={isEnded}
              inputs={inputs}
              />
          </div>

      </div>
     
     </form>
     
   }
   {
    user && isInterestedInReferral && <ShowReferralForm />

   }

    {
      
      !user &&  isDone && <Done />
   }
  
   </>
  
  );
}


export  {App};





